import { useMutation } from '@tanstack/react-query';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { callService } from '@api/caller';
import { CallMeFormRequestViewModel } from '@api/index';
import {
  LetUsCallYouFormData,
  LetUsCallYouProps,
} from '@components/ui/LetUsCallYou/types';

const useCallMeFrom = ({
  entityId,
  entityName,
  price,
  currency,
  salesItemType,
  availabilityStatus,
  formCheckInDate,
  formCheckOutDate,
  hotelRoomList,
  onFormSendSuccess,
  itemCountryCode,
}: LetUsCallYouProps) => {
  const {
    mutate,
    isLoading: isPostCallMeLoading,
    error,
    isSuccess: isPostCallMeSuccess,
  } = useMutation(
    ['letUsCallYou'],
    (requestBody: CallMeFormRequestViewModel) =>
      callService('TicketsService', 'callMeForm', { requestBody }),
    {
      onSuccess: () => {
        onFormSendSuccess ? onFormSendSuccess() : null;
      },
    }
  );

  const { executeRecaptcha } = useGoogleReCaptcha();

  const onSubmit = async ({
    firstName,
    lastName,
    email,
    phone,
    contactOption,
    availableTime,
    message,
  }: LetUsCallYouFormData) => {
    if (!executeRecaptcha) return;
    const token = await executeRecaptcha('letUsCallYou');

    mutate({
      firstName,
      lastName,
      email,
      phone: phone?.replace(/\D/g, ''),
      countryCode: '+90',
      contactOption,
      message,
      entityId,
      entityName,
      price,
      currency,
      token,
      formCheckInDate:
        formCheckInDate && formCheckInDate.isValid()
          ? formCheckInDate.format('YYYY-MM-DDTHH:mm:ss')
          : undefined,
      formCheckOutDate:
        formCheckOutDate && formCheckOutDate.isValid()
          ? formCheckOutDate.format('YYYY-MM-DDTHH:mm:ss')
          : undefined,
      roomList: hotelRoomList?.map((hotelRoom) => ({
        adultCount: hotelRoom.adultCount,
        childList: hotelRoom.childrenList?.map(({ age }) => ({
          childBirthDate: String(age).split('/').reverse().join('-'),
        })),
      })),
      availabilityStatus,
      availableTime,
      salesItemType,
      itemCountryCode,
    });
  };

  return {
    onSubmit,
    isPostCallMeLoading,
    error,
    isPostCallMeSuccess,
  };
};

export default useCallMeFrom;
